// Notes - multiple autosaved notes kept in localStorage.
import { el, btn, ta, wrap, saveFlag } from "./ui.js";
import { readJSON, writeJSON } from "../shared/store.js";
import { bump, dateKey } from "../shared/activity.js";

const KEY = "revault:notes";
const load = () => { const v = readJSON(KEY, []); return Array.isArray(v) ? v : []; };
const save = (n) => writeJSON(KEY, n);
let counted = ""; // notes count once a day in the study ledger
const titleOf = (body) => (body || "").split("\n")[0].trim().slice(0, 40) || "Untitled";

function helperOn() {
	try { const f = localStorage.getItem("revault:helper:flag") || "off"; const st = JSON.parse(localStorage.getItem("revault:settings") || "{}"); return f !== "off" && st.extHelper !== false; } catch (e) { return false; }
}
// Inside the app the side panel opens with the note attached; on its own the Helper page opens.
function toHelper(msg) {
	if (window.parent && window.parent !== window) { try { window.parent.postMessage({ type: "revault-helper-open", ...msg }, location.origin); return; } catch (e) { /* standalone */ } }
	try { localStorage.setItem("revault:helper:handoff", JSON.stringify({ ...msg, at: Date.now() })); } catch (e) { /* private mode */ }
	location.href = "/tools/helper";
}

// Study Helper hand-off: always a new note, never an edit to an existing one.
export function addNote(title, text) {
	const list = load();
	const body = (String(title || "").trim() ? String(title).trim().slice(0, 80) + "\n\n" : "") + String(text || "");
	const n = { id: Date.now() + "" + Math.floor(Math.random() * 1000), body, ts: Date.now() };
	list.unshift(n);
	save(list);
	return n.id;
}
export function listNotes() { return load().map((n) => ({ id: n.id, title: titleOf(n.body), length: (n.body || "").length })); }
export function noteText(id) { const n = load().find((x) => x.id === id); return n ? n.body : ""; }

export function notes(root) {
	const s = wrap(root); s.classList.add("rv-notes");
	let list = load();
	let activeId = list[0] ? list[0].id : null;
	const flag = saveFlag();
	const store = () => flag.set(save(list));

	const aside = el("div", "rv-notes-list");
	const editor = ta({ placeholder: "Start typing…", spellcheck: true });
	editor.setAttribute("aria-label", "Note");
	editor.classList.add("rv-notes-editor");

	function renderList() {
		aside.textContent = "";
		const head = el("div", "rv-notes-head");
		head.append(btn("+ New", newNote, "rv-tbtn rv-tbtn-accent"));
		aside.appendChild(head);
		if (!list.length) { aside.appendChild(el("p", "rv-tnote", "No notes yet.")); return; }
		list.forEach((n) => {
			const item = el("div", "rv-notes-item" + (n.id === activeId ? " active" : ""));
			const open = btn(titleOf(n.body), null, "rv-notes-item-title");
			if (n.id === activeId) open.setAttribute("aria-current", "true");
			item.append(open);
			const del = btn("✕", (e) => { e.stopPropagation(); removeNote(n.id); }, "rv-notes-del");
			del.setAttribute("aria-label", "Delete note: " + titleOf(n.body));
			item.append(del);
			item.addEventListener("click", (e) => { activeId = n.id; sync(); if (e.target.closest && e.target.closest(".rv-notes-item-title")) editor.focus(); });
			aside.appendChild(item);
		});
	}
	function current() { return list.find((n) => n.id === activeId); }
	function sync() {
		const n = current();
		editor.value = n ? n.body : "";
		editor.disabled = !n;
		renderList();
	}
	function newNote() {
		const n = { id: Date.now() + "" + Math.floor(performance.now()), body: "", ts: Date.now() };
		list.unshift(n); activeId = n.id; store(); sync(); editor.focus();
	}
	function removeNote(id) {
		list = list.filter((n) => n.id !== id);
		if (activeId === id) activeId = list[0] ? list[0].id : null;
		store(); sync();
	}
	editor.addEventListener("input", () => {
		const n = current(); if (!n) return;
		n.body = editor.value; n.ts = Date.now(); store();
		if (counted !== dateKey()) { counted = dateKey(); bump("n"); }
		const t = aside.querySelector(".rv-notes-item.active .rv-notes-item-title");
		if (t) t.textContent = titleOf(n.body);
	});

	// "Study Helper" menu: hand this note (or the selected part) to the Helper in a mode.
	const main = el("div", "rv-notes-main");
	if (helperOn()) {
		const bar = el("div", "rv-notes-helper");
		bar.setAttribute("role", "group"); bar.setAttribute("aria-label", "Study Helper");
		bar.append(el("span", "rv-notes-helper-label", "Study Helper:"));
		for (const [mode, label] of [["summarize", "Summarize"], ["quiz", "Quiz me"], ["cards", "Make flashcards"]]) {
			bar.append(btn(label, () => {
				const n = current(); if (!n || !n.body.trim()) return;
				const sel = editor.selectionEnd > editor.selectionStart ? editor.value.slice(editor.selectionStart, editor.selectionEnd) : "";
				toHelper({ mode, title: titleOf(n.body) + (sel ? " (selection)" : ""), text: sel || n.body });
			}, "rv-tbtn"));
		}
		main.append(bar);
	}
	main.append(flag, editor);
	s.append(aside, main);
	sync();
}
